module.exports = __webpack_public_path__ + "img/203.6e936340.jpeg";